import { Typography } from 'src/components-v2/DataDisplay';
import BtnTertiary from 'src/components-v2/Inputs/Button/BtnTertiary';
import { Box, Stack } from 'src/components-v2/Layout';
import { ICareersSearchItemProps } from './CareersSearch.types';
import styled from 'threads5/themes/styled';

const LinkBox = styled(Box)(({ theme }) => {
  return {
    position: 'relative',
    display: 'block',
    width: '100%',
    borderRadius: '12px',
    boxShadow:
      '0px 0px 2px 0px rgba(17, 17, 18, 0.04), 0px 2px 8px 1px rgba(17, 17, 18, 0.08)',
    '&:before': {
      transition: 'opacity 200ms ease-in',
      opacity: 0,
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: '1.5rem',
      backgroundImage: theme.palette['web3/component/shadow'],
      filter: 'blur(10px)',
      transform: 'translateZ(0)',
    },
    '&:hover:before, &:focus-within:before': {
      opacity: 0.6,
    },
    'a:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  };
});

const LinkStack = styled(Stack)(({ theme }) => {
  return {
    backgroundColor: theme.palette['base/white'],
    borderRadius: '12px',
    width: '100%',
    padding: '16px 24px',
    transform: 'translateZ(0)',
  };
});

const CareersSearchItem = ({ job }: ICareersSearchItemProps) => {
  const jobPath = `/careers/openings/${job.key}/`;

  return (
    <LinkBox>
      <LinkStack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent='space-between'
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={3}
      >
        <Stack gap={1}>
          <Typography
            variant='p4'
            sx={{
              color: 'text/contrast-low',
            }}
          >
            {job.locations.join(', ')}
          </Typography>
          <Typography
            variant='p'
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.8rem', sm: '2rem' },
            }}
          >
            {job.title}
          </Typography>
        </Stack>
        <BtnTertiary href={jobPath} sx={{ whiteSpace: 'nowrap', p: 0 }}>
          See role
        </BtnTertiary>
      </LinkStack>
    </LinkBox>
  );
};

export default CareersSearchItem;
